﻿import { Product } from '../model/Product';
const productUrl = '/ppapi/Product';

export class Products extends Array {
    constructor(...args) {
        super(...args);
        this.page = 1;
    }

    get url() {
        return productUrl;
    }

    static get [Symbol.species]() {
        return Array;
    }

    async get(page = 1, count = 10, type = 'full', groupId, search) {
        let url = `${this.url}?page=${page}&count=${count}&type=${type}`;

        if (typeof name == 'string' && name != '') {
            url += `&search=${name}`;
        }

        if (typeof groupId == 'number' && groupId > 0) {
            url += `&group=${groupId}`;
        }

        const response = await fetch(url, {
            method: 'GET',
            cache: 'no-cache'
        });
        const results = await response.json();

        if (results.length > 0) {
            results.forEach((item, key, arr) => {
                if (
                    type == 'full'
                    && this.some(i => i.id == item.ID)
                ) {
                    const priceIndex = this.findIndex(i => i.id == item.ID);

                    if (typeof item.Name !== "undefined") {
                        this[priceIndex].name = item.Name;
                    }

                    if (typeof item.Art !== "undefined") {
                        this[priceIndex].art = item.Art;
                    }

                    if (typeof item.GroupID !== "undefined") {
                        this[priceIndex].groupId = item.GroupID;
                    }

                    if (typeof item.MetricID !== "undefined") {
                        this[priceIndex].metricId = item.MetricID;
                    }

                    if (typeof item.OrderNumber !== "undefined") {
                        this[priceIndex].orderNumber = item.OrderNumber;
                    }

                    if (typeof item.Price !== "undefined") {
                        this[priceIndex].price = item.Price;
                    }

                    if (typeof item.MinPrice !== "undefined") {
                        this[priceIndex].minPrice = item.MinPrice;
                    }

                    if (typeof item.InputPrice !== "undefined") {
                        this[priceIndex].inputPrice = item.InputPrice;
                    }

                    if (typeof item["Delete"] !== "undefined") {
                        this[priceIndex].isDelete = item["Delete"];
                    }

                    if (typeof item.MaxProportion !== "undefined") {
                        this[priceIndex].maxProportion = item.MaxProportion;
                    }

                    if (typeof item.MinProportion !== "undefined") {
                        this[priceIndex].minProportion = item.MinProportion;
                    }

                    delete this[priceIndex].short;
                } else {
                    const product = new Product({
                        id: item.ID,
                        groupId: item.GroupID,
                        metricId: item.MetricID,
                        orderNumber: item.OrderNumber
                    });

                    product.short = true;
                    this.push(product);
                }
            });
        }

        return (results.length > 0);
    }

    async next(groupId, callback) {
        this.page++;
        await this.get(this.page, 10, 'full', groupId);
    }
}

export async function getProducts({
    products,
    page,
    count,
    type,
    groupId,
    search
}) {
    if (typeof products == 'undefined') {
        products = new Products();
    }

    if (typeof page != 'number' || page <= 0) {
        page = 1;
    }

    if (typeof count != 'number' || count <= 0) {
        count = 10;
    }

    if (typeof type != 'string' || type == '') {
        type = 'full';
    }

    let url = `${productUrl}?page=${page}&count=${count}&type=${type}`;

    if (typeof search == 'string' && search != '') {
        url += `&search=${search}`;
    }

    if (typeof groupId == 'number' && groupId > 0) {
        url += `&group=${groupId}`;
    }

    const response = await fetch(url, {
        method: 'GET',
        cache: 'no-cache'
    });
    const results = await response.json();

    if (results.length > 0) {
        results.forEach((item, key, arr) => {
            if (type == 'full') {
                if (products.some(i => i.id == item.ID)) {
                    const priceIndex = products.findIndex(i => i.id == item.ID);

                    if (typeof item.Name !== "undefined") {
                        products[priceIndex].name = item.Name;
                    }

                    if (typeof item.Art !== "undefined") {
                        products[priceIndex].art = item.Art;
                    }

                    if (typeof item.GroupID !== "undefined") {
                        products[priceIndex].groupId = item.GroupID;
                    }

                    if (typeof item.MetricID !== "undefined") {
                        products[priceIndex].metricId = item.MetricID;
                    }

                    if (typeof item.OrderNumber !== "undefined") {
                        products[priceIndex].orderNumber = item.OrderNumber;
                    }

                    if (typeof item.Price !== "undefined") {
                        products[priceIndex].price = item.Price;
                    }

                    if (typeof item.MinPrice !== "undefined") {
                        products[priceIndex].minPrice = item.MinPrice;
                    }

                    if (typeof item.InputPrice !== "undefined") {
                        products[priceIndex].inputPrice = item.InputPrice;
                    }

                    if (typeof item["Delete"] !== "undefined") {
                        products[priceIndex].isDelete = item["Delete"];
                    }

                    if (typeof item.MaxProportion !== "undefined") {
                        products[priceIndex].maxProportion = item.MaxProportion;
                    }

                    if (typeof item.MinProportion !== "undefined") {
                        products[priceIndex].minProportion = item.MinProportion;
                    }

                    products[priceIndex].short = false;
                } else {
                    products.push(new Product({
                        id: item.ID,
                        groupId: item.GroupID,
                        metricId: item.MetricID,
                        orderNumber: item.OrderNumber,
                        name: item.Name,
                        art: item.Art,
                        price: item.Price,
                        minPrice: item.MinPrice,
                        inputPrice: item.InputPrice,
                        isDelete: item["Delete"],
                        maxProportion: item.MaxProportion,
                        minProportion: item.MinProportion
                    }));
                }
            } else {
                const product = new Product({
                    id: item.ID,
                    groupId: item.GroupID,
                    metricId: item.MetricID,
                    orderNumber: item.OrderNumber
                });

                product.short = true;
                products.push(product);
            }
        });
    }

    return (results.length > 0);
}

export async function nextProducts(products, groupId) {
    products.page++;
    await getProducts({ page: products.page, count: 10, groupId });
}